import { parse } from 'qs';
import { useState, useEffect } from 'react';
import { type Dictionary } from 'ts-essentials';

export const useNavigationChange = () => {
  const [destination, setDestination] = useState<
    Dictionary<string> & { url?: string }
  >();

  useEffect(() => {
    if ('navigation' in window) {
      const onNavigate = (e) => {
        setDestination(e.destination);
      };

      // @ts-expect-error: navigate event is in experimental phase
      navigation.addEventListener('navigate', onNavigate);

      return () => {
        // @ts-expect-error: navigate event is in experimental phase
        navigation.removeEventListener('navigate', onNavigate);
      };
    }
  }, []);

  return {
    destination,
    params: parse(destination?.url ?? ''),
  };
};
